import { render, staticRenderFns } from "./catalogueItem.vue?vue&type=template&id=7ea8610b&scoped=true"
import script from "./catalogueItem.vue?vue&type=script&lang=js"
export * from "./catalogueItem.vue?vue&type=script&lang=js"
import style0 from "./catalogueItem.vue?vue&type=style&index=0&id=7ea8610b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea8610b",
  null
  
)

export default component.exports